import { Stack, Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import TalkInput from "components/talk/TalkInput";
import { collection, query } from "firebase/firestore";
import { db } from "firebaseApp";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { getTalkId } from "utils/talk";
import { useTheme } from "@emotion/react";
import ScrollableCollection from "components/react-lib/generic-ui/ScrollableCollection";
import TalkMessage from "components/talk/TalkMessage";

export default function ActiveTalk() {

  const theme = useTheme();
  const params = useParams();
  const auth = useAuth();

  const uid1 = auth.currentUser.uid;
  const uid2 = params.friendId;
  const talkId = getTalkId(uid1, uid2);

  const messageQuery = query(collection(db, "talks", talkId, "messages"));

  const renderPrefixElements = () => {
    return (
      <Typography sx={{ color: theme.palette.text.main }} textAlign="center">
        This is the start of this conversation.
      </Typography>
    );
  };

  const renderSuffixElements = () => {
    return null;
  };

  const renderMessage = (message, indexFromStart, indexFromEnd) => {
    return <TalkMessage message={message} />;
  };

  const renderMessages = () => {
    return (
      <ScrollableCollection
        collectionQuery={messageQuery}
        renderElement={renderMessage}
        renderPrefixElements={renderPrefixElements}
        renderSuffixElements={renderSuffixElements}
        containerStyle={{
          flexGrow: 1,
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
        clickToLoad={true}
      />
    );
  };

  return (
    <Stack
      spacing={1}
      alignItems="center"
      justifyContent="center"
      sx={{
        boxSizing: "border-box",
        width: "100%",
        height: "100%",
        overflowY: "hidden",
      }}
      px={3}
      py={2}
    >
      {renderMessages()}
      
      <TalkInput />
    </Stack>
  );
}
